import './style.scss';
import divBlockMeta from './block.json';
import { divIcon as icon } from './icon';
import edit from './edit';
import save from './save';
import attributeVisibility from '@components/visibility/attributes.json'; // eslint-disable-line
import attributeClassDropDown from '@components/class-dropdown/attributes.json'; // eslint-disable-line
import { attributeFlexSettings } from '@components/flex-settings/attributes';
import { attributeBackgroundTypes } from '@components/background-types/attributes';
import { getBlockLabelByName } from '@helpers/utils';

const { registerBlockType } = wp.blocks;
const { name, ...settings } = divBlockMeta;

const attributes = {
  ...settings.attributes,
  ...attributeClassDropDown,
  ...attributeVisibility,
  ...attributeFlexSettings,
  ...attributeBackgroundTypes,
};

registerBlockType(name, {
  ...settings,
  attributes,
  icon,
  edit,
  save,
  __experimentalLabel: (attributes) =>
    getBlockLabelByName(attributes, settings.title),
});
